import classnames from 'classnames'
import React from 'react'
import { Row } from '@scentregroup/ui'
import style from './index.module.scss'

interface IButtonRow {
  stackedInReverseOrder?: boolean
  className?: string
}

const ButtonRow: React.FunctionComponent<
  React.PropsWithChildren<IButtonRow>
> = ({ stackedInReverseOrder, children, className }) => {
  return (
    <Row
      className={classnames(className, style.buttons, {
        [style.reverse]: stackedInReverseOrder,
      })}
    >
      {children}
    </Row>
  )
}

export default ButtonRow
